import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { api, authStatusQuery } from "../api.js";
import { AuthForm } from "../components/auth-form.js";
import { isNative } from "../platform/native.js";
import { ServerFooter } from "./login.js";

export function SetupPage() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // spec08 FR6: the first account is created in the browser, never in the app.
  if (isNative) {
    return (
      <AuthForm
        title="Set up Ronin in the browser first"
        description="This server has no account yet. Open it in a browser, create the first account there, then come back and sign in."
        submitLabel="Check again"
        fields={[]}
        onSubmit={async () => {
          queryClient.removeQueries({ queryKey: authStatusQuery.queryKey });
          await navigate({ to: "/login" });
        }}
        footer={<ServerFooter />}
      />
    );
  }

  return (
    <AuthForm
      title="Set up Ronin"
      description="Create the first account. The setup token is the SETUP_TOKEN from your server environment."
      submitLabel="Create account"
      fields={[
        { name: "setupToken", label: "Setup token", type: "password", autoComplete: "off" },
        { name: "email", label: "Email", type: "email", autoComplete: "email" },
        { name: "username", label: "Username", type: "text", autoComplete: "username" },
        {
          name: "password",
          label: "Password",
          type: "password",
          autoComplete: "new-password",
          hint: "At least 12 characters.",
        },
      ]}
      onSubmit={async ({ email = "", username = "", password = "", setupToken = "" }) => {
        await api.auth.setup({ email, username, password, ...(setupToken && { setupToken }) });
        // Drop the cached state so the route guards fetch the new session.
        queryClient.removeQueries({ queryKey: authStatusQuery.queryKey });
        await navigate({ to: "/todos" });
      }}
    />
  );
}
